import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

const useModalRoute = ( { name }: { name: string } ) => {
	const location = useLocation();
	const history = useHistory();

	useEffect( () => {
		const searchParams = new URLSearchParams( location.search );

		if ( !searchParams.get( 'modal' ) ) {
			searchParams.set( 'modal', name );
			history.push( {
				search: searchParams.toString(),
				state: location.state
			} );
		}

		return () => {
			const cleanupSearchParams = new URLSearchParams( location.search );

			if ( cleanupSearchParams.get( 'modal' ) === name ) {
				cleanupSearchParams.delete( 'modal' );
				history.replace( {
					search: cleanupSearchParams.toString(),
					state: location.state
				} );
			}
		};
	}, [ name, location.search, history, location.state ] );
};

export default useModalRoute;
